<app-header [identifier]="identifier" [theme]="theme"></app-header>
<div class="container">
  <div class="row jobClosed">
    <div class="col-12 py-4">
      <p class="text-danger">404</p>
      <p class="mb-0">The selected job was not found.
      Click <a [routerLink]="'/' + identifier + subBrandIdentifierPath">here</a> to see a list of our current open positions.</p>
    </div>
  </div>
  <app-footer [theme]="theme"></app-footer>
</div>